import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../providers/auth.service';

import { faDotCircle, faLock }  from '@fortawesome/fontawesome-pro-regular';

import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-adopt-identity-login',
  templateUrl: './adopt-identity-login.component.html',
styleUrls:  ['./adopt-identity-login.component.css']
})
export class AdoptIdentityLoginComponent  extends SmsAbstractAppPage  implements OnInit {

	model: any = {};
  	loading = false;
  	faDotCircle = faDotCircle;
  	faLock = faLock;

  constructor(private router: Router, private authService: AuthService) {
  	super();
  }

  login() {
        this.loading = true;
        this.authService.adopt_user_login(this.model.username, this.model.password, this.model.their_username, this.model.their_email)
            .then(result => {
                if (result == true) {
                    // Full page load, not a router navigation: services hold the
                    // previous user in BehaviorSubjects (SessionService.user$ and
                    // friends) and a soft navigate would carry that state into the
                    // adopted session. This also lets AppComponent pick up the
                    // adopted-identity banner.
                    window.location.href = '/';
                } else {
                    // login failed
                    this.handleError('Username or password is incorrect');
                    this.loading = false;
                }
            }).catch(error => {
              this.handleError(error);
            });
    }

  ngOnInit() {
  }

}
